import React, {Fragment} from "react";
import CommonHeader from "../../components/Headers/CommonHeader";
import AddContact from "../../components/Modal/AddContact";
import ProtectedContent from "../../components/protectedContent";
import SafeView from "../../components/safeView/SafeView";
import PageURLContextProvider from "../../contexts/pageURLContext";
import {useDisclosure} from "../../hooks/useDisclosure";
import ContactsTable from "./contactsTable";

export const ContactsComponent = () => {
  const {
    isOpen: isAddContactOpen,
    onOpen: openAddContact,
    onClose: closeAddContact,
  } = useDisclosure();
  return (
    <SafeView>
      <ProtectedContent perms={["view_customercontactperson"]} showFallback>
        <Fragment>
          {isAddContactOpen && (
            <AddContact open={isAddContactOpen} onCancel={closeAddContact} />
          )}
          <ProtectedContent perms={["add_customercontactperson"]}>
            <CommonHeader
              content={"Add Contact"}
              handleAddClick={openAddContact}
              testID={"add_contacts"}
            />
          </ProtectedContent>
          <ContactsTable />
        </Fragment>
      </ProtectedContent>
    </SafeView>
  );
};

const ContactsPage = () => {
  return (
    <PageURLContextProvider>
      <ContactsComponent />
    </PageURLContextProvider>
  );
};

export default ContactsPage;
